
import calendarMixin from "@/mixins/calendarMixin";
// @group Dashboard
export default {
  mixins: [calendarMixin],
  data() {
    return {
      records: {} as Record<
        string,
        Record<
          string,
          {
            Planned_scheme_deadline: {
              id: string;
              type: string;
              report_id: string;
            }[];
            Dataset_delivery_deadline: {
              id: string;
              type: string;
              report_id: string;
            }[];
          }
        >
      >
    };
  }
};
